import { Component, EventEmitter, Input, OnInit, Output, OnChanges, ViewChild } from '@angular/core';
import { AbstractControl, NgModel } from '@angular/forms';
import { ScreensQuestionResource } from '@Components/mras/core';
import { SharedModule } from '@Shared/shared.module';

@Component({
    selector: 'jhi-height-input',
    templateUrl: './height-input.component.html',
    imports: [SharedModule]
})
export class HeightInputComponent implements OnInit, OnChanges {
    @ViewChild(NgModel, { static: true }) feetInput: NgModel;
    @ViewChild(NgModel, { static: true }) inchInput: NgModel;
    @Input() question: ScreensQuestionResource;
    @Input()
        value: string;
    @Output()
        valueChange = new EventEmitter<string>();
    @Output()
        action = new EventEmitter();

    @Input()
        summaryMode: boolean;

    @Input()
        name: string;
    @Input()
        placeholder: string;
    @Input()
        disabled: boolean;
    @Input()
        enableChangeButton: boolean;

    numericValue: number;
    feetValue: number;
    inchValue: number;
    validValue = true;

    ngOnInit(): void {
        if (this.value != null) {
            this.numericValue = Number.parseFloat(this.value);
        }
        
        this.feetValue = Math.floor(this.numericValue / 12);
        this.inchValue = this.numericValue % 12;

        this.feetInput.control.setValidators(() => {
            const valid = this.validateMinMax();
            if (!valid) {
                this.feetInput.control.setErrors(valid ? null : { minmax: true });
                return;
            }

            return null;
        });

        
        this.inchInput.control.setValidators(() => {
            const valid = this.validateMinMax();
            if (!valid) {
                this.inchInput.control.setErrors(valid ? null : { minmax: true });
                return;
            }

            return null;
        });
    }

    ngOnChanges(): void {
        this.numericValue = Number.parseInt(this.value);

    }

    validateMinMax() {
        const finalValue = this.feetValue * 12 + this.inchValue;

        const minInches = 36;
        const maxInches = 95;

        if (Number.isNaN(finalValue) || finalValue < minInches || finalValue > maxInches) {
            this.question.invalid = true;
            return false;
        }

        this.question.invalid = false;
        return true;
    }

    onClick() {
        if (!this.feetValue || this.feetValue === null) {
            this.validValue = false;
            this.question.invalid = true;
            return;
        }

        if (!this.inchValue || this.inchValue === null){
            this.inchValue = 0;
        }

        const finalValue = this.feetValue * 12 + this.inchValue;
        
        if (finalValue && finalValue !== null) {
            this.valueChange.emit(null);
        }

        if (!this.validateMinMax()) {
            this.validValue = false;
            this.question.invalid = true;
            return;
        }

        if (this.question.invalid) {
            this.question.invalid = false;
        }

        this.valueChange.emit(finalValue.toString(10));
        this.action.emit(null);
    }
}
